export default __webpack_public_path__ + "static/alibaba-b8c3a609d0ca74511f2b404524b8795b.svg";